import { RegistrationStatus } from '@fieldday/fielddayportal-model'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined'
import TodayIcon from '@mui/icons-material/Today'
import { Box, Stack, Typography, useMediaQuery } from '@mui/material'
import { useNonprofitContext } from '../../hooks/commonOrgContext'
import { useAuth } from "../../hooks/useAuth"
import { useScheduledActivityContext } from '../../hooks/useScheduledActivityContext'
import { Location } from '../../models/Activity'
import theme from "../../styles/theme"
import { tsFormatLocationDate, tsFormatLocationTime } from '../../util/dateUtil'
import LocationPreviewBox from '../Locations/LocationPreviewBox'

export function AddressDetails({ location }: { location: Location }) {
  const { name, address1, address2, city, state, zipcode } = location
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box>
      <Typography variant={mobileView ? "body2" : "body1"}>
        {name}
      </Typography>
      {name !== address1 && <Typography variant={mobileView ? "body2" : "body1"}>
        {address1}
      </Typography>}
      <Typography variant={mobileView ? "body2" : "body1"}>
        {address2}
      </Typography>
      <Typography variant={mobileView ? "body2" : "body1"}>
        {city}, {state} {zipcode}
      </Typography>
    </Box>
  )
}

export default function ScheduledActivityDetailsBox() {
  const { scheduledActivity: sa } = useScheduledActivityContext()
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'))
  const mdView = useMediaQuery(theme.breakpoints.down("md"))

  // ensure that there is an activity
  if (!sa.activity) {
    return (
      <Typography>An unexpected error occured while loading the Activity.</Typography>
    )
  }

  return (
    <Box margin={0}>
      <Stack direction="row" mb={2} spacing={mobileView ? 1.5 : 2} alignItems="start">
        <TodayIcon color="primary" sx={{ mt: .5 }} />
        <Box>
          <Typography variant={mobileView ? "body2" : "body1"}>
            {tsFormatLocationDate(sa.location, sa.timestampUTC)}
          </Typography>
          <Typography variant={mobileView ? "body2" : "body1"}>
            {tsFormatLocationTime(sa.location, sa.timestampUTC, sa.durationInMinutes)}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={mobileView ? 1.5 : 2} alignItems="start">
        <FmdGoodOutlinedIcon color="primary" sx={{ mt: .5 }} />
        <LocationDetails />
        {sa.location && mdView && <LocationPreviewBox location={sa.location} eventPage setWidth="30%" />}
      </Stack>
    </Box>
  )
}



const LocationDetails = () => {
  const { scheduledActivity: sa } = useScheduledActivityContext()
  const { canCoordinate } = useNonprofitContext()
  const { user } = useAuth()
  const myReg = user?.registrations.find(r => r.scheduledActivityId === sa.id)
  const isRegistered = myReg?.status === RegistrationStatus.Registered
  const linkAndIsRegistered = sa.link && isRegistered
  const linkAndIsCoordinator = sa.link && canCoordinate()

  if (sa.location) {
    return <AddressDetails location={sa.location} />
  } else {
    return (
      <Box>
        <Typography variant="subtitle1" color="textSecondary" fontStyle="italic">
          {linkAndIsRegistered || linkAndIsCoordinator ?
            <a href={sa.link} >
              Link to virtual {sa.orgUnitId ? "Field Trip" : "event"}
            </a>
            : "Virtual"
          }
        </Typography>
      </Box>
    )
  }
}
